// extracted by mini-css-extract-plugin
export default {"app-secret-key-page":"AppSecretKeyPage_app-secret-key-page__jFmW4"};